import _ from 'lodash';
import { combineReducers } from 'redux';

import {
  createApiReducer,
  INITIAL_API_STATE,
  Status,
  chainReducers,
} from 'src/api';
import { IMPERSONATE_ACCOUNT } from 'src/user/redux/actions';

import {
  SIGN_IN_START,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_OUT,
  CLEAR_AUTH_ERRORS,
} from './actions';

export const createSignInApiReducer = dataAdapter =>
  createApiReducer(
    [SIGN_IN_START, SIGN_IN_SUCCESS, SIGN_IN_FAILURE],
    response => {
      // Special handling for 2FA responses
      if (response && response.code === '2fa_required') {
        return {
          // Don't set tokens for 2FA responses
          is2faRequired: true,
          ...response,
        };
      }
      // Normal authentication response
      return dataAdapter(response);
    },
    error => ({
      message: _.get(error, 'payload.detail', 'unknown error'),
      code: _.get(error, 'payload.code'),
    })
  );

const transformToken = response => ({
  accessToken: _.get(response, 'access'),
  refreshToken: _.get(response, 'refresh'),
});

const signInApi = createSignInApiReducer(transformToken);

const signOutReducer = (state, action) => {
  if (action.type === SIGN_OUT) {
    return {
      ...state,
      ...INITIAL_API_STATE,
      status: {
        state: Status.CLEAR,
        error: null,
        errorMessage: null,
      },
    };
  }
  return state;
};

const clearAuthErrorsReducer = (state, action) => {
  if (action.type === CLEAR_AUTH_ERRORS) {
    return {
      ...state,
      status: {
        state: state.status.state,
        error: null,
        errorMessage: null,
      },
    };
  }
  return state;
};

const setSelectedAccountReducer = (state, action) => {
  if (action.type === IMPERSONATE_ACCOUNT) {
    return {
      ...state,
      data: {
        ...state.data,
        selectedAccountId: action.payload.accountId,
        selectedAccountName: action.payload.accountName,
        selectedAccountHasConsents: action.payload.hasConsents,
        selectedAccountHasDocuments: action.payload.hasDocuments,
      },
    };
  }
  return state;
};

const token = chainReducers(
  INITIAL_API_STATE,
  signInApi,
  signOutReducer,
  clearAuthErrorsReducer
);

const settings = chainReducers(
  INITIAL_API_STATE,
  setSelectedAccountReducer,
  signOutReducer
);

export const reducer = combineReducers({
  token,
  settings,
});
